export enum DeviceTypeName {
  TRUCK = 'truck',
  VAN = 'van',
}
